import React, { Component } from 'react'
import Dialog from "./../../../../../components/dialog-base"
import './styles.scss'
import connector from 'src/decorators/connector'
import { IStoresMap } from 'src/types'


interface IFlatsNumbersProps {
    onClose: () => void
    item: {
        id: string,
        img: string,
        name: string,
        price: number,
        size: string,
        type: number
    }
}

class FlatsNumbersPopUp extends React.Component<IFlatsNumbersProps & ReturnType<typeof storesToProps>> {
    public state = {
        startFlat: 1,
        endFlat: 1,
        entrNumber: 1,
    }

    public onChangeEntrNumber = (number: number) => {
        if (this.state.entrNumber + number >= 1) {
            this.setState({ entrNumber: this.state.entrNumber + number })
        }

    }


    public minusStartFlat = () => {
        if (this.state.startFlat > 1) {
            this.setState({ startFlat: this.state.startFlat - 1 })
        }
    }
    public minusEndFlat = () => {
        if (this.state.endFlat > 1 && this.state.endFlat > this.state.startFlat) {
            this.setState({ endFlat: this.state.endFlat - 1 })
        }
    }

    public plusStartFlat = () => {
        if (this.state.endFlat > this.state.startFlat) {
            this.setState({ startFlat: this.state.startFlat + 1 })
        } else {
            this.setState({ startFlat: this.state.startFlat + 1, endFlat: this.state.startFlat + 1 })
        }
    }
    public plusEndFlat = () => {
        this.setState({ endFlat: this.state.endFlat + 1 })
    }

    public get allCount() {
        return this.state.endFlat - this.state.startFlat + 1
    }

    public onAddProduct = () => {
        const { addProduct } = this.props.busket
        const { startFlat, endFlat, entrNumber } = this.state
        let descriptions = `c ${startFlat} по ${endFlat}`

        if (this.props.item.type === 47 ){
            descriptions = `подъезд №${entrNumber} ` + descriptions
        }

        addProduct(this.props.item, 1, this.state.startFlat, this.state.endFlat, descriptions)
        this.props.onClose()
    }


    render() {
        const { startFlat, endFlat } = this.state

        return <Dialog onClose={this.props.onClose}>
            <div className={`floors_number_container popup-${this.props.item.type}`}>
                <img className="dialogClose" onClick={this.props.onClose} src="/local/templates/sign_plus/images/close.svg" alt="" />
                <div className="dialogContaine__inner">
                    <div className="title">
                        {this.props.item.name}
                    </div>
                    <div className="top_block">
                        <img className={this.props.item.type === 39 ? "big_picture" : "small_picture"} src={this.props.item.img} />
                        <div className="title">{this.props.item.type === 48 ? "Парковочные места" : "Квартиры"}</div>
                        {this.props.item.type === 47 && <div className="enrtCount">
                            <div className="title">Номер подъезда</div>
                            <div className='swither_container'>
                                <div className="minus" onClick={() => this.onChangeEntrNumber(-1)}>-</div>
                                <div className="count">{this.state.entrNumber}</div>
                                <div className="plus" onClick={() => this.onChangeEntrNumber(1)}>+</div>
                            </div>
                        </div>}
                        <div className="numbers">
                            <div className="with">{this.props.item.type === 47 ? "Квартиры с" : "c"}</div>
                            <div className='swither_container'>
                                <div className="minus" onClick={this.minusStartFlat}>-</div>
                                <div className="count">{startFlat}</div>
                                <div className="plus" onClick={this.plusStartFlat}>+</div>
                            </div>
                            <div className="on">по</div> <div className="minus" onClick={this.minusEndFlat}>-</div>
                            <div className="count">{endFlat}</div>
                            <div className="plus" onClick={this.plusEndFlat}>+</div>
                        </div>
                    </div>
                    <div className="bottom_block">
                        <div className="price">{this.props.item.price} руб/шт</div>
                        <div className="count">{1} шт</div>
                        <div className="allPrice">{this.props.item.price} руб</div>
                    </div>
                    <div className="inBusker" onClick={this.onAddProduct}>В корзину</div>
                </div>

            </div>
        </Dialog>
    }
}

const storesToProps = ({ store }: IStoresMap, _nextProps: any) => ({
    busket: store.BusketStore
})

export default connector(storesToProps)(FlatsNumbersPopUp)
